/**
 * Club Management section sub-navigation.
 *
 * Shared across the TM pages (Teams, Players). Mirrors EmailNav — a
 * clean tab strip with a bottom-border active indicator — so Teams +
 * Players read as one coherent module instead of two disconnected
 * sidebar links.
 *
 * Players is a staged-rollout feature (features.players); its tab is
 * shown only when enabled, matching the sidebar's own gate.
 */
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './TeamNav.css';

export default function TeamNav() {
  const { features } = useAuth();
  const playersEnabled = features?.players === true;
  const membersEnabled = features?.members === true;
  const collectionsEnabled = features?.collections === true;
  // Collections is built on the people layer, so it reveals Players + Members
  // + Guardians too. Coaches stays Members-only (not collections-relevant).
  const roster = playersEnabled || collectionsEnabled;
  const people = membersEnabled || collectionsEnabled;
  const location = useLocation();

  const tabs = [
    { to: '/teams', label: 'Teams', show: true },
    { to: '/players', label: 'Players', show: roster },
    { to: '/members', label: 'Members', show: people },
    { to: '/coaches', label: 'Coaches', show: membersEnabled },
    { to: '/guardians', label: 'Guardians', show: people },

  ];

  return (
    <nav className="tm-nav" aria-label="Club management sections">
      <div className="tm-nav-tabs">
        {tabs.filter(t => t.show).map(tab => {
          const isActive = location.pathname === tab.to;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={`tm-nav-tab ${isActive ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
